module.exports = __webpack_public_path__ + "static/media/1019038.628e6b39.png";